const URL = {
	install(Vue, options) {

		Vue.prototype.$URL = {
			set: function(param) {
				var hash = window.location.hash;
				var default_hash = "";
				hash = hash.replace('#', '');

				hash = hash.split('/');

				var url = {};
				for (var i in hash) {

					if (!hash[i]) continue;

					if (!hash[i].match('=')) {
						if (default_hash) default_hash += '/';
						default_hash += hash[i];
						continue;
					}

					var hash_param = hash[i].split('=');
					url[hash_param[0]] = "";

					if (hash_param[1] !== undefined ) url[hash_param[0]] = hash_param[1];
				}

				for (var index in param) {
					url[index] = param[index];
				}

				hash = "";

				for (var index in url) {
					if (hash) hash += "/";
					if (url[index] !== null) hash += index+"="+url[index];
				}

				window.location.hash = default_hash+"/"+hash;
			},
			get: function(arg) {
				var param = window.location.hash;
				var params = {};
				param = param.replace('#', '');

				param = param.split('/');

				for (var i in param) {
					var pair = param[i].split('=');
					if (!pair[0] || pair[1] == undefined) continue;
					params[pair[0]] = decodeURIComponent(pair[1]);
					if (arg && pair[0] == arg) return params[pair[0]];
				}

				if (arg) return null;
				else return params;
			}
		}

	}
};

export default URL;